<template>
  <div class="indexBg">
    <div class="help-item">
      <div class="title"># 如何才能方便快速的找到小程序</div>
      <div class="box">
        <div class="step-item">
          <div class="step">
           第一步：在微信页面下拉弹出搜索框
          </div>
          <el-image
            class="imgSrc"
            :src="require('@/assets/help/img5-1.png')"
            :preview-src-list="[require('@/assets/help/img5-1.png')]"
            fit="contain"
          >
          </el-image>
        </div>
        <div class="step-item">
          <div class="step">
            第二步：找到“老友智汇”小程序，没有的话就点击右上角搜索按钮进行搜索
          </div>
          <el-image
            class="imgSrc"
            :src="require('@/assets/help/img5-2.png')"
            :preview-src-list="[require('@/assets/help/img5-2.png')]"
            fit="contain"
          >
          </el-image>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "help1Page",
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},

  async created() {},
  mounted() {},

  beforeDestroy() {},

  methods: {},
};
</script>

<style scoped lang="less">
.indexBg {
  width: 100%;
  height: 100%;
  background: #eeeeee;
  font-family: Alibaba PuHuiTi;
}
.help-item {
  padding: 30px;
  .title {
    color: rgba(0, 0, 0, 1);
    font-family: Alibaba PuHuiTi;
    font-size: 45px;
    font-weight: 600;
    letter-spacing: 0px;
    text-align: left;
    margin: 0px 0 45px;
  }
  .box {
    background: #ffffff;
    padding: 30px;
    border-radius: 20px;
  }
  .step-item {
    margin-bottom: 30px;

    .step {
      font-size: 36px;
      margin-bottom: 20px;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
